import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { questionColumnsConfig } from "../config/Question";
import { ConfirmPopup } from "../Confirmation";
import { useNavigate } from "react-router-dom"; 
import { getCategoryWithFilter } from "../../../slices/thunks";

export const getQuestionColumns = ({ onDeleteClick, onEditClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  useEffect(() => {
    dispatch(getCategoryWithFilter())
      .then((res) => {
        const categoryList = Array.isArray(res.payload?.data)
          ? res.payload.data
          : [];
        setCategories(categoryList);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setCategories([]);
      });
  }, [dispatch]);
    // Helper to get category name by ID
    const getCategoryName = (category_id) => {
      const category = categories.find((cat) => cat.id === category_id);
      return category?.name || "N/A";
    };

  
// console.log(confirmOpenForId);
const handleEditClick = (row) => {
  navigate("/quize-question/add-form", { state: { id: row.id } }); // Pass the row ID to the /addform page
};
  return [
 
    {
      name: <span className="font-weight-bold fs-13">{questionColumnsConfig.CATEGORYID}</span>,
      selector: (row) => getCategoryName(row.category_id), // ✅ replaced with category name
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{questionColumnsConfig.QUESTION}</span>,
      selector: (row) => row.text, // Assuming `row.question` holds the question text
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{questionColumnsConfig.TYPE}</span>,
      selector: (row) => {
        const type = row.type ? row.type.toLowerCase() : "";
        const isMcq = type === "mcq";
    
        return (
          <span
            className={`px-3 py-1 rounded-pill fw-semibold fs-13 text-white ${
              isMcq ? "bg-primary" : "bg-warning text-dark"
            }`}
          >
            {type ? type.toUpperCase() : "N/A"}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{questionColumnsConfig.CORRECTANSWERL}</span>,
      selector: (row) => row.correct_answer, // Assuming `row.correctAnswer` holds the correct answer
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{questionColumnsConfig.ACTIONS}</span>,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 justify-content-center">
          {/* Edit Button */}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              handleEditClick(row); // Navigate and pass the ID to /addform
            }}
            className="fs-13 nav-link"
          >
            <i className="ri-edit-2-fill fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle"></i>
          </a>

          {/* Delete Button */}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setConfirmOpenForId(row.id);
            }}
            className="fs-13 nav-link"
          >
            <i
  className="ri-delete-bin-7-fill fs-16 p-2 bg-soft-danger rounded-circle align-middle icon-red"
></i>
   </a>

          {/* Confirm Delete Popup */}
          {confirmOpenForId === row.id && (
            <ConfirmPopup
              message={questionColumnsConfig.messages} // Updated message from questionColumnsConfig
              setConfirmOpen={() => setConfirmOpenForId(null)}
              onConfirm={() => {
                onDeleteClick(row.id); // Removed event since it's not needed here
                setConfirmOpenForId(null);
                
              }}
            />
          )}
        </div>
      ),
    },
    
  ];
};
